// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"744":"12eea4c0","916":"12eea4c0","993":"52c05f49"}[chunkId] + ".chunk.css";
};